
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  HStack,
  Heading,
  Text,
  Icon,
  Link,
} from '@chakra-ui/react';
import { FaMicrochip } from 'react-icons/fa';

const Footer = () => {
  return (
    <Box bg="gray.800" color="white" py={12}>
      <Container maxW="container.xl">
        <VStack spacing={8}>
          <HStack spacing={4}>
            <Icon as={FaMicrochip} color="brand.400" boxSize={8} />
            <Heading size="lg" color="brand.400">Scale-Resolving Simulation (SRS)</Heading>
          </HStack>
          <Text color="gray.400" textAlign="center">
           © 2026 SRS, a NumericalAI product by Empirisch Tech GmbH (empirischtech.at). All rights reserved. |
            <Link as={RouterLink} to="/privacy" color="brand.400" ml={2}>
              Privacy Policy
            </Link> |
            <Link as={RouterLink} to="/terms" color="brand.400" ml={2}>
              Terms of Service
            </Link> |
            <Link as={RouterLink} to="/executive-brief" color="brand.400" ml={2}>
              Executive brief
            </Link> |
            <Link as={RouterLink} to="/faq" color="brand.400" ml={2}>
              FAQ
            </Link>
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;